import * as base from '../base';
import { PeopleSearchRequest } from '../../../models/overmind/search-request';
import { EmployeeSearchResponse } from '../../../models/view/employee-search-response';
import { Context } from '../..';
import { NotificationPriority, NotificationType } from '../../../notifications/notifications.models';
import { GetUserDto, SaveUserDto } from '../../../models/view/employee';

const CONTROLLER = `freemiumpeople`;

export async function freemiumDeletePerson(context: Context, userId: string): Promise<void> {
  const companySlug = context.state.companyVariables.slug;
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `${userId}${base.params({ companySlug: companySlug })}`), method: 'DELETE' };
  const response = await base.request(request);

  if (!!response.error) {
    context.actions.addNotification({
      id: crypto.randomUUID(),
      title: 'Something went wrong',
      message: 'Our team has been notified. Please contact support for help.',
      priority: NotificationPriority.Toast,
      type: NotificationType.Error,
      active: true,
    });
  }
}

export async function freemiumSearchPeople(context: Context, searchRequest: PeopleSearchRequest): Promise<EmployeeSearchResponse | undefined> {
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `search-employees`, `${searchRequest.companySlug}${base.params(searchRequest)}`) };
  const response: base.IResponse<EmployeeSearchResponse> = await base.request(request);

  return response.data;
}

export async function freemiumGetPerson(context: Context, id: string): Promise<GetUserDto | undefined> {
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `get-employee`, id) };
  const response: base.IResponse<GetUserDto> = await base.request(request);
  return response.data;
}

export async function freemiumSavePerson(context: Context, payload: SaveUserDto): Promise<string | undefined> {
  const url = base.apiURL(CONTROLLER, `save-employee`, context.state.companyVariables.slug!);
  const request: base.IRequest = { url, method: 'POST', body: JSON.stringify(payload) };
  const response: base.IResponse<string> = await base.request(request);

  if (!!response.error) {
    context.actions.addNotification({
      id: Date.now().toString(),
      title: 'Error',
      message: response.error.detail,
      priority: NotificationPriority.Toast,
      type: NotificationType.Error,
      active: true,
    });
    return undefined;
  }

  context.actions.addNotification({
    id: Date.now().toString(),
    title: `Person ${!!response.data ? 'edited' : 'created'}`,
    message: `${payload.firstName} ${payload.lastName} has successfully been ${!!payload.id ? 'edited' : 'created'}`,
    priority: NotificationPriority.Toast,
    type: NotificationType.Success,
    active: true,
  });
  return response.data;
}
